const Profile = () => {
    return (
        <div className="cartbox">
            <table className="table">
                <tr>
                    <td> <i class="fa-solid fa-cart-shopping"></i></td>
                    <td> <i class="fa-solid fa-circle-user"></i> </td>
                    <td> <i class="fa-solid fa-lock"></i> </td>
                </tr>
                <tr>
                    <td> <button> Order History </button> </td>
                    <td> <button> Change Username </button> </td>
                    <td> <button> Change Password </button> </td>
                </tr>
            </table>
        </div>
    );
}

export default Profile;